<template>
  <div class="main">
    <div class="title">倡议书</div>

    <div class="content">
      <div class="">朋友们:</div>

      <div
        class="sj "
      >白血病是当前严重威胁人类生命的一种疾病，发病年龄多在35岁以下，50%以上是儿童，我国现有400多万名白血病患者，每年约3万名患者黯然逝去。目前，挽救白血病患者生命最有效的手段是造血干细胞移植。找到与病人白细胞抗原相同的造血干细胞志愿捐献者，是实施移植的前提条件。一名白血病患者在一万至十几万人中才可能找到一个与其抗原相同者。造血干细胞捐献志愿者越多，患者获得配型成功的几率就越大，获得新生的希望就越大。</div>

      <div
        class="sj "
      >捐献造血干细胞分两个阶段：一是报名和血样采集阶段。在18至45周岁身体健康的志愿者静脉抽取6-8毫升血液进行HLA（白细胞抗原）分型，并将有关资料输入数据库。二是实施捐献阶段。从配型成功的志愿者手臂静脉处采集，通过血细胞分离机提取富含造血干细胞的血浆， 其他血液成分自动回输捐献志愿者体内，不会损害身体健康。</div>

      <div
        class="sj "
      >造血干细胞捐献是一项拯救生命的善心工程，需要全社会的关心、支持和参与。在此，我们倡议各界爱心人士，踊跃加入到造血干细胞志愿捐献者队伍，用爱心和行动重燃白血病患者的生命之光。</div>

      <div class="sj ">生命因奉献而美丽，社会因关爱而和谐。让我们行动起来，积极投身捐献造血干细胞这项崇高事业，拯救生命，奉献爱心，参与公益，升华自我。</div>
    </div>
    
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  // height: 950px;
  font-size: 14px;
  min-height: 100vh;
  background-image: url("../../assets/zxgxb/bg.png");
  background-size: cover;

  .title {
    margin-top: 120px;
    font-size: 30px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;
    padding: 25px;
    // height: 700px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>